import loggerService from '@/services/logger.service';

export const deepClone = (val: Record<string, any>) => {
  try {
    return JSON.parse(JSON.stringify(val));
  } catch (error) {
    loggerService.error('Error while deep cloning object!!', error);
    return {};
  }
};
